import * as APITypes from "~/API";
import {
  getPropertyList,
  getBuildingList,
  getUnitList,
  getParcelList,
} from "~/services/server";

/**
 * Build a map of properties keyed by property ID
 */
export const buildPropertyMap = async (
  ownerID: string,
  ownerType: APITypes.OwnerType
): Promise<Record<string, APITypes.Property>> => {
  const propertyList = await getPropertyList({ ownerID, ownerType });
  const propertyMap: Record<string, APITypes.Property> = {};

  propertyList.data.forEach((property: APITypes.Property) => {
    propertyMap[property.id] = property;
  });

  return propertyMap;
};

/**
 * Build a map of buildings keyed by building ID
 */
export const buildBuildingMap = async (
  ownerID: string,
  ownerType: APITypes.OwnerType
): Promise<Record<string, APITypes.Building>> => {
  const buildingList = await getBuildingList({ ownerID, ownerType });
  const buildingMap: Record<string, APITypes.Building> = {};

  buildingList.data.forEach((building: APITypes.Building) => {
    buildingMap[building.id] = building;
  });

  return buildingMap;
};

/**
 * Build a map of units keyed by unit ID
 */
export const buildUnitMap = async (
  ownerID: string,
  ownerType: APITypes.OwnerType
): Promise<Record<string, APITypes.Unit>> => {
  const unitList = await getUnitList({ ownerID, ownerType });
  const unitMap: Record<string, APITypes.Unit> = {};

  unitList.data.forEach((unit: APITypes.Unit) => {
    unitMap[unit.id] = unit;
  });

  return unitMap;
};

/**
 * Build a map of parcels keyed by parcel ID
 */
export const buildParcelMap = async (
  ownerID: string,
  ownerType: APITypes.OwnerType
): Promise<Record<string, APITypes.Parcel>> => {
  const parcelList = await getParcelList({ ownerID, ownerType });
  const parcelMap: Record<string, APITypes.Parcel> = {};

  parcelList.data.forEach((parcel: APITypes.Parcel) => {
    parcelMap[parcel.id] = parcel;
  });

  return parcelMap;
};
